import { render } from "./NewEditcustomer.vue?vue&type=template&id=2825db04"
import script from "./NewEditcustomer.vue?vue&type=script&lang=js"
export * from "./NewEditcustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__